/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Tool_Bulk_Count_CreatesInputs */



/**
* | output |
* | --- |
* | "{count} creates" |
*
* @param {Chat_Tool_Bulk_Count_CreatesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_bulk_count_creates = /** @type {((inputs: Chat_Tool_Bulk_Count_CreatesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Bulk_Count_CreatesInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Erstellungen`)
	return /** @type {LocalizedString} */ (`${i?.count} creates`)
});